/* =========================
   MWY – site scripts (clean drop-in)
   ========================= */

(() => {
  'use strict';

  /* -------------------------
   * Config
   * ------------------------- */
  const FREE_SHIPPING_THRESHOLD = 75.0;
  const MOBILE_MAX = 990; // Motion mobile breakpoint
  const IDS = {
    freeMsg: 'free-shipping-message',
    freeMsgDrawer: 'free-shipping-message-drawer',
    usBanner: 'us-shipping-banner',
    navDrawer: 'NavDrawer',
  };

  /* -------------------------
   * Helpers
   * ------------------------- */
  const isUS = () => typeof Shopify !== 'undefined' && Shopify.country === 'US';
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const fetchCart = () => fetch('/cart.js').then((r) => r.json());

  /* -------------------------
   * Free shipping messages
   * ------------------------- */
  async function updateFreeShippingMessage() {
    const msgEl = document.getElementById(IDS.freeMsg);
    const bannerEl = document.getElementById(IDS.usBanner);
    if (!msgEl && !bannerEl) return; // nothing to do

    // Non-US: hide all shipping promos
    if (!isUS()) {
      if (msgEl) msgEl.style.display = 'none';
      if (bannerEl) bannerEl.style.display = 'none';
      return;
    }

    try {
      const cart = await fetchCart();
      const subtotal = (cart.total_price || 0) / 100;
      const diff = Math.max(0, FREE_SHIPPING_THRESHOLD - subtotal).toFixed(2);

      if (cart.item_count > 0) {
        // Hide default banner; show dynamic message
        if (bannerEl) bannerEl.style.display = 'none';
        if (msgEl) {
          msgEl.style.display = 'block';
          if (subtotal >= FREE_SHIPPING_THRESHOLD) {
            msgEl.innerHTML = '✅ You Qualified for <em>FREE</em> shipping!';
          } else {
            msgEl.innerHTML = `📦 You're <strong>$${diff}</strong> away from <em>FREE</em> shipping!`;
          }
        }
      } else {
        // Empty cart: show default banner; hide dynamic message
        if (bannerEl) bannerEl.style.display = 'block';
        if (msgEl) msgEl.style.display = 'none';
      }
    } catch (err) {
      console.error('Free shipping (cart page) error:', err);
    }
  }

  async function updateFreeShippingMessageDrawer() {
    const el = document.getElementById(IDS.freeMsgDrawer);
    if (!el) return;

    if (!isUS()) {
      el.style.display = 'none';
      return;
    }

    el.style.display = 'block';
    try {
      const cart = await fetchCart();
      const subtotal = (cart.total_price || 0) / 100;
      const diff = Math.max(0, FREE_SHIPPING_THRESHOLD - subtotal).toFixed(2);

      if (subtotal >= FREE_SHIPPING_THRESHOLD) {
        el.innerHTML = '✅ You Qualified for <em>FREE</em> shipping!';
      } else {
        el.innerHTML = `📦 You're <strong>$${diff}</strong> away from <em>FREE</em> shipping!`;
      }
    } catch (err) {
      console.error('Free shipping (drawer) error:', err);
    }
  }

  
  /* -------------------------
   * Cart-related event wiring
   * ------------------------- */
  function wireCartEvents() {
    // Initial load
    updateFreeShippingMessage();
    updateFreeShippingMessageDrawer();

    // After +/- quantity clicks
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.qty__adjust')) return;
      setTimeout(() => {
        updateFreeShippingMessage();
        updateFreeShippingMessageDrawer();
      }, 500);
    });

    // When any "open drawer" control is clicked, refresh the drawer message
    document.addEventListener('click', (e) => {
      const opener = e.target.closest('[data-action="open-drawer"], [aria-controls="CartDrawer"], [data-drawer-id="CartDrawer"]');
      if (!opener) return;
      // Refresh after drawer animation
      setTimeout(updateFreeShippingMessageDrawer, 500);
    });

    // After product is added via AJAX or on cart form submit
    document.addEventListener('submit', (e) => {
      const addForm = e.target.closest('form[action^="/cart/add"]');
      if (addForm) {
        setTimeout(() => {
          updateFreeShippingMessage();
          updateFreeShippingMessageDrawer();
        }, 800);
      }

      const cartForm = e.target.closest('form[action="/cart"]');
      if (cartForm) {
        setTimeout(() => {
          updateFreeShippingMessage();
          updateFreeShippingMessageDrawer();
        }, 800);
      }
    });

    // Watch subtotal DOM updates on the cart page
    const subtotalEl = document.querySelector('[data-subtotal]');
    if (subtotalEl) {
      const observer = new MutationObserver(() => {
        updateFreeShippingMessage();
        updateFreeShippingMessageDrawer();
      });
      observer.observe(subtotalEl, { characterData: true, childList: true, subtree: true });
    }
  }

  /* -------------------------
   * Init
   * ------------------------- */
  function init() {
    wireCartEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* -------------------------
 * MOBILE NAV (Motion) — auto-expand first level when #NavDrawer opens
 * Self-contained; does not depend on the code above.
 * ------------------------- */
(() => {
  const MOBILE_MAX = 990;                // adjust if your mobile breakpoint differs
  const NAV_ID = 'NavDrawer';
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  function isVisible(el) {
    if (!el) return false;
    if (el.getAttribute('aria-hidden') === 'true') return false;
    const r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  function expandFirstLevel(drawer) {
    if (!drawer || window.innerWidth > MOBILE_MAX) return;
    const toggles = $$('.mobile-nav > li .collapsible-trigger[aria-controls^="Linklist-"]', drawer);
    toggles.forEach(btn => {
      if (btn.getAttribute('aria-expanded') !== 'true') btn.click(); // use theme's own handler
    });
    drawer.dataset._autoExpanded = '1';
  }

  function onPossibleOpen() {
    const drawer = document.getElementById(NAV_ID);
    if (!drawer) return;
    if (isVisible(drawer) && drawer.dataset._autoExpanded !== '1') expandFirstLevel(drawer);
    if (!isVisible(drawer)) delete drawer.dataset._autoExpanded;
  }

  function init() {
    const drawer = document.getElementById(NAV_ID);
    if (!drawer) return;

    // Try immediately (theme editor cases)
    onPossibleOpen();

    // Observe drawer attribute/class changes
    const mo = new MutationObserver(onPossibleOpen);
    mo.observe(drawer, { attributes: true, attributeFilter: ['class', 'style', 'aria-hidden'] });

    // Some builds toggle classes on <html>
    const moRoot = new MutationObserver(onPossibleOpen);
    moRoot.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

    // Also react when open buttons are clicked
    document.addEventListener('click', (e) => {
      if (e.target.closest('[aria-controls="NavDrawer"], [data-drawer-id="NavDrawer"], [href="#NavDrawer"]')) {
        setTimeout(onPossibleOpen, 50);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
